// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1Ce4I","title":"style__title___2OsSy","title_memorial":"style__title_memorial___16Yt8","inner":"style__inner___1p8oU","inner_memorial":"style__inner_memorial___fKIlB"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/bubble-container/style.css
// module id = 1326
// module chunks = 0